module.exports = __webpack_public_path__ + "img/drink_coupon_chiba_old.91841b0c.png";